import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import userReducer from "./userSlice";
import toastReducer from "./toastSlice";
import configReducer from "./configSlice";

const rootReducer = combineReducers({
    user : userReducer,
    toast : toastReducer,
    config : configReducer
})

const persistConfig = {
    key : "root",
    rootReducer,
    version: 1,
    storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer : persistedReducer,
    middleware : (getDefaultMiddleware) => 
        getDefaultMiddleware({
            serializableCheck : {
                ignoreActions : [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        })
})

const persistor = persistStore(store);

export {
    store, 
    persistor
}
